import { api } from './api'
import type { Config } from '@/api/types/config'

export const configApi = {
  getWorkspaceConfig: async (org_id: string, ws_id: string): Promise<Config> => {
    console.log(`🔍 Fetching config for org ${org_id}, workspace ${ws_id}`)
    const response = await api.get<Config>('/config', { 
      is_workspace_specific: true 
    })
    console.log('✅ Fetched workspace config:', response.data)
    return response.data
  },

  updateWorkspaceConfig: async (org_id: string, ws_id: string, data: Partial<Config>): Promise<Config> => {
    console.log(`✏️ Updating config for org ${org_id}, workspace ${ws_id}:`, data)
    const response = await api.put<Config>('/config', data, { 
      is_workspace_specific: true 
    })
    console.log('✅ Updated workspace config:', response.data)
    return response.data
  }
}